import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "react-drag-n-drop-image";
import { toast } from "react-toastify";
import moment from "moment";

const CustomBody = () => {
  return (
    <div
      className="drag-file-area mt-0"
      style={{
        border: "0px",
        borderRadius: "0px",
        width: "100%",
        position: "relative",
      }}
    >
      <div>
        <CloudDownloadIcon style={{ fontSize: "50px" }} />
      </div>
      <h3 className="dynamic-message" style={{ fontFamily: "Montserrat" }}>
        Drag &amp; drop any file here
      </h3>
      <label className="">
        <span className="">
          <span
            className="browse-files-text"
            style={{
              fontFamily: "Montserrat",
              color: "#539ffe",
            }}
          >
            browse file
          </span>
          <span style={{ fontFamily: "Montserrat" }}>from device</span>
        </span>
      </label>
    </div>
  );
};

function ShowData({ files, onRemoveImage }) {
  return (
    <div className="">
      {files.map((item) => {
        return (
          <>
            <div
              className="drag-file-area mt-0"
              style={{
                border: "0px",
                borderRadius: "0px",
                position: "relative",
              }}
            >
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div style={{ height: "200px", width: "200px" }} className="">
                  <img
                    src={item.preview}
                    alt="preview..."
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </div>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  // onClick={() => {
                  //   setDragImage2(true);
                  //   setImage2(null);
                  // }}
                  onClick={() => onRemoveImage(item.id)}
                />
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default function Poll() {
  const { socket } = useAppContext();

  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [imageFile, setImageFile] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [showImages, setShowData] = React.useState(false);
  const [isEditDataImage1, setIsEditDataImage1] = React.useState(false);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [totalLength, setTotalLength] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  // View dialog state
  const [viewDialogOpen, setViewDialogOpen] = React.useState(false);
  const [viewPlayers, setViewPlayers] = React.useState([]);
  const [viewLoader, setViewLoader] = React.useState(false);
  const [viewDialogTitle, setViewDialogTitle] = React.useState("");

  const fetchPollById = async (item) => {
    setViewDialogTitle(item.game_name);
    setViewDialogOpen(true);
    setViewLoader(true);
    setViewPlayers([]);
    try {
      const res = await axios.get(`${API_URL}/api/admin/poll/get-poll/${item._id}`);
      if (res.data.status) {
        setViewPlayers(res.data.data.game_count || []);
      } else {
        toast.error("Failed to fetch poll details.");
      }
    } catch (err) {
      console.error("fetchPollById error:", err);
      toast.error("Error fetching poll details.");
    } finally {
      setViewLoader(false);
    }
  };

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
    setPageNumber(Math.floor(start / showPrePage) + 1);
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPageNumber(1);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    game_name: Yup.string().required("required"),
    status: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, [pageNumber, showPrePage, search]);

  // Close dialog on ESC key
  React.useEffect(() => {
    if (!viewDialogOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setViewDialogOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [viewDialogOpen]);

  const getBranch = () => {
    setLoader(true);
    axios.get(`${API_URL}/api/admin/poll/get-poll`, {
      params: {
        page: pageNumber,
        limit: showPrePage,
        search: search,
      },
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        setTableData(response.data.data);
        setTotalLength(response.data.pagination?.totalDocs || response.data.data.length);
      })
      .catch((error) => {
        setLoader(false);
        console.log("getBranch error :::", error);
      });
  };

  const IsEditOnRemoveImage = () => {
    setShowData(false);
    console.log("isEditOnRemove::: ");
    setFiles([]);
    setIsEditDataImage1(false);
  };

  const onRemoveImage = (id) => {
    setShowData(false);
    setFiles((prev) => prev.filter((i) => i.id !== id));
  };

  const onError = (error) => {
    console.error(error);
  };

  const onChange = (e) => {
    if (files.length === 0) {
      console.log(e[0].file.name, "true");
      setShowData(true);
      setImageFile(e[0].file);
      setFiles(e);
    }
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setIsEditDataImage1(true);
    console.log("item edit value :::", item.image);
    console.log("value:::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    console.log("imageFile :::", imageFile);
    setImageFile();
    setIsEditDataImage1(false);
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    const formData = new FormData();
    formData.append("status", value?.status);
    formData.append("game_name", value?.game_name);

    if (imageFile) {
      formData.append("poll-image", imageFile);
    }

    axios(`${API_URL}/api/admin/poll/update-poll/${rowValue._id}`, {
      method: "PATCH",
      credentials: "include",
      data: formData,
    })
      .then((res) => {
        if (res.data.status) {
          successAdd(res.data.message);
          setbuttonLoader(false);
          socket.emit("bannerUpdate");
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("update err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    if (!imageFile) {
      toast.error("Image is required");
      setbuttonLoader(false);
      return;
    }

    const formData = new FormData();
    formData.append("status", value.status);
    formData.append("game_name", value.game_name);
    formData.append("poll-image", imageFile);

    axios(`${API_URL}/api/admin/poll/add-poll`, {
      method: "POST",
      credentials: "include",
      data: formData,
    })
      .then((result) => {
        if (result.data.status) {
          setbuttonLoader(false);
          socket.emit("bannerAdd");
          successAdd(result.data.message);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        setbuttonLoader(false);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this poll record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The poll record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);

    axios
      .delete(`${API_URL}/api/admin/poll/delete-poll/${e._id}`)
      .then((res) => {
        console.log(res);
        if (res.data.status) {
          successDeleted();
          socket.emit("bannerDelete");
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The poll has been processed successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}

      {/* View Players Dialog */}
      {viewDialogOpen && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setViewDialogOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "16px",
              width: "480px",
              maxWidth: "95vw",
              maxHeight: "80vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
              overflow: "hidden",
            }}
          >
            {/* Dialog Header */}
            <div style={{ padding: "20px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div>
                <h5 style={{ margin: 0, fontWeight: 700, color: "#1e293b", fontSize: "1.05rem" }}>Players in Poll</h5>
                <p style={{ margin: 0, fontSize: "0.82rem", color: "#64748b", marginTop: "2px" }}>{viewDialogTitle}</p>
              </div>
              <button
                onClick={() => setViewDialogOpen(false)}
                style={{ background: "#f1f5f9", border: "none", borderRadius: "8px", width: "32px", height: "32px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <ClearIcon style={{ fontSize: "18px", color: "#64748b" }} />
              </button>
            </div>

            {/* Dialog Body — sticky header + scrollable body */}
            <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
              {viewLoader ? (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 0" }}>
                  <div className="spinner-border" role="status" style={{ color: "#ffc107", width: "40px", height: "40px" }}>
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : viewPlayers.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8" }}>
                  <i className="fas fa-users" style={{ fontSize: "40px", marginBottom: "12px", display: "block" }}></i>
                  <p style={{ margin: 0, fontWeight: 500 }}>No players found</p>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
                  {/* Sticky header */}
                  <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <colgroup>
                      <col style={{ width: "60px" }} />
                      <col />
                      <col />
                    </colgroup>
                    <thead>
                      <tr style={{ background: "#f8fafc" }}>
                        <th style={{ padding: "10px 16px", textAlign: "left", fontSize: "0.78rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #e2e8f0" }}>#</th>
                        <th style={{ padding: "10px 16px", textAlign: "left", fontSize: "0.78rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #e2e8f0" }}>Player ID</th>
                        <th style={{ padding: "10px 16px", textAlign: "left", fontSize: "0.78rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "2px solid #e2e8f0" }}>Name</th>
                      </tr>
                    </thead>
                  </table>
                  {/* Scrollable body */}
                  <div style={{ overflowY: "auto", flex: 1 }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                      <colgroup>
                        <col style={{ width: "60px" }} />
                        <col />
                        <col />
                      </colgroup>
                      <tbody>
                        {viewPlayers.map((player, idx) => (
                          <tr key={player._id || idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                            <td style={{ padding: "12px 16px", fontSize: "0.9rem", color: "#64748b" }}>{idx + 1}</td>
                            <td style={{ padding: "12px 16px", fontSize: "0.9rem", color: "#1e293b", fontWeight: 600 }}>{player.playerId || "-"}</td>
                            <td style={{ padding: "12px 16px", fontSize: "0.9rem", color: "#475569" }}>{player.name || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {/* Dialog Footer */}
            <div style={{ padding: "14px 24px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "0.82rem", color: "#94a3b8" }}>
                {!viewLoader && `${viewPlayers.length} player${viewPlayers.length !== 1 ? "s" : ""}`}
              </span>
              <button
                onClick={() => setViewDialogOpen(false)}
                className="btn btn-secondary"
                style={{ height: "36px", borderRadius: "8px", fontSize: "0.88rem" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  game_name: rowValue ? rowValue?.game_name : "",
                  status: rowValue ? rowValue?.status : false,
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log("values...", values);
                  console.log("openValue...", openValue);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values }) => (
                  <Form>
                    <div className="row">
                      {/* Game Name & Status */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Game Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="game_name"
                            placeholder="Enter Game Name"
                            className={`mt-1 form-control ${touched.game_name && errors.game_name ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="game_name" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Poll Status <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="status"
                            className={`mt-1 form-control ${touched.status && errors.status ? "is-invalid" : ""}`}
                          >
                            <option value={true}>Active</option>
                            <option value={false}>InActive</option>
                          </Field>
                          <ErrorMessage component="div" name="status" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      {/* Image Section */}
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="mb-2">Poll Banner Image</label>
                          {isEditDataImage1 ? (
                            <div
                              style={{
                                border: "1px dashed #f5a623",
                                borderRadius: "8px",
                                padding: "20px",
                                position: "relative",
                                minHeight: "240px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#fafafa"
                              }}
                            >
                              <div className="position-relative d-flex justify-content-center align-items-center" style={{ width: "100%", height: "200px" }}>
                                {/* Loading Shimmer / Spinner */}
                                <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 1 }}>
                                  <div className="spinner-border" role="status" style={{ opacity: 0.3, color: "#f5a623" }}></div>
                                </div>

                                <img
                                  src={rowValue?.image_url}
                                  alt="preview"
                                  style={{
                                    maxHeight: "200px",
                                    maxWidth: "100%",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                    zIndex: 2,
                                    position: "relative",
                                    opacity: 0,
                                    transition: "opacity 0.4s ease-in-out"
                                  }}
                                  onLoad={(e) => {
                                    e.target.style.opacity = 1;
                                  }}
                                />
                              </div>
                              <CloseIcon
                                style={{
                                  cursor: "pointer",
                                  color: "#dc3545",
                                  position: "absolute",
                                  right: 15,
                                  top: 15,
                                  background: "#fff",
                                  borderRadius: "50%",
                                  padding: "2px",
                                  fontSize: "26px",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                  zIndex: 3
                                }}
                                onClick={() => IsEditOnRemoveImage()}
                              />
                            </div>
                          ) : (
                            <div className="file-upload-box">
                              {showImages ? (
                                <ShowData files={files} onRemoveImage={onRemoveImage} />
                              ) : (
                                <FileUpload
                                  onError={onError}
                                  body={<CustomBody />}
                                  overlap={false}
                                  fileValue={files}
                                  onChange={(e) => onChange(e)}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-4 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card">
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="d-flex align-items-center flex-wrap gap-3">
                    <div className="position-relative mb-3 mb-md-0" style={{ minWidth: '320px' }}>
                      <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                      <input
                        type="text"
                        className="form-control premium-search-input"
                        placeholder="Search by game name..."
                        style={{ paddingLeft: '42px', borderRadius: '12px', border: '1.5px solid #e2e8f0', height: '45px', transition: 'all 0.2s ease' }}
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setPageNumber(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4 text-right">
                  <button
                    onClick={() => {
                      getBranch();
                    }}
                    type="button"
                    className="btn btn-outline-primary mr-2"
                    style={{ height: '45px', borderRadius: '12px', padding: '0 20px' }}
                  >
                    <i className="fas fa-sync-alt mr-1"></i> Refresh
                  </button>
                  {accessObject?.bannerAdd === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                      }}
                      type="button"
                      className="btn btn-primary"
                      style={{ height: '45px', borderRadius: '12px', padding: '0 25px' }}
                    >
                      Create
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Game Name</th>
                    <th>Game Count</th>
                    <th>Status</th>
                    <th>Enroll Users</th>
                    {accessObject?.bannerEdit === true && <th>Action</th>}
                  </tr>
                </thead>
                {accessObject?.getBannerList === true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                ?.map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + (pageNumber - 1) * showPrePage}</td>
                                      <td>{moment(item.createdAt).format("DD/MM/YYYY")}</td>
                                      <td>{item.game_name}</td>
                                      <td>{item.game_count.length}</td>
                                      <td>{item.status ? "Active" : "InActive"}</td>
                                      <td style={{ textAlign: "center" }}>
                                        <button
                                          onClick={() => fetchPollById(item)}
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
                                            border: "none",
                                            borderRadius: "20px",
                                            padding: "5px 14px",
                                            cursor: "pointer",
                                            color: "#1e293b",
                                            fontWeight: 700,
                                            fontSize: "0.78rem",
                                            boxShadow: "0 3px 8px rgba(255,193,7,0.35)",
                                            transition: "all 0.2s ease",
                                            whiteSpace: "nowrap",
                                          }}
                                          onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 6px 14px rgba(255,193,7,0.45)"; }}
                                          onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 3px 8px rgba(255,193,7,0.35)"; }}
                                        >
                                          <i className="fas fa-users" style={{ fontSize: "0.75rem" }}></i>
                                          View
                                        </button>
                                      </td>
                                      <td className="d-flex justify-content-evenly ">
                                        {accessObject?.bannerEdit === true && (
                                          <EditIcon
                                            className="mr-3 courser"
                                            onClick={() =>
                                              clickEditButton(item)
                                            }
                                          />
                                        )}
                                        {accessObject?.bannerDelete ===
                                          true && (
                                            <ClearIcon
                                              className="courser text-danger"
                                              onClick={() =>
                                                warningWithConfirmMessage(item)
                                              }
                                            />
                                          )}
                                      </td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={5} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={4}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getBannerList === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getBannerList === true && totalLength !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={totalLength}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
